export default __webpack_public_path__ + "static/media/remos-signal-flex.398f6274.png";